import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import axiosSetting from './untils/axios-setting'
import tools from './untils/tools'
import CurrentUser from './untils/current-user'
import "mand-mobile/components/_style/global.styl";
import "normalize.css";
import "./global.scss";

import { localize } from 'vee-validate';
import zhCN from 'vee-validate/dist/locale/zh_CN.json';
import { Toast,Dialog } from 'mand-mobile'


Vue.config.productionTip = false;
// Vue.prototype.$router = router;
//console.log(process.env);

axiosSetting.init();
Vue.prototype.$http = axios;
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$tools = tools;


localize('zh_CN', zhCN);
CurrentUser.getInstance().setAuthHeader();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
